import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { MaxBrainAudience } from './audience.model';

export class AudienceStateModel extends EntityStateModel<MaxBrainAudience> {}
